<script setup lang="ts">
import { computed } from "vue";

import { backendOld } from "~/api";
import AvatarUpload from "~/components/AvatarUpload.vue";
import EditText from "~/components/dumb/EditText.vue";
import Toggle from "~/components/dumb/Toggle.vue";
import SettingsCopyText from "~/components/settings/SettingsCopyText.vue";
import SettingsRow from "~/components/settings/SettingsRow.vue";
import SettingsSection from "~/components/settings/SettingsSection.vue";
import { usePageStore, useTenantStore } from "~/stores";
import { makeValidateTenantName } from "~/utils/validation";

type TenantStore = ReturnType<typeof useTenantStore>;

const pageStore = usePageStore();
const tenantStore = useTenantStore();

const validateTenantName = computed(() => makeValidateTenantName(tenantStore.isDart));

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const updateWorkspaceSetting = (settingName: keyof TenantStore, newValue: any) => {
  // TODO fix this type hack
  tenantStore[settingName as "name"] = newValue;
  backendOld.workspace.edit(settingName, newValue);
};
</script>

<template>
  <div>
    <SettingsSection title="Information" class="!mt-0">
      <div class="flex gap-4">
        <AvatarUpload kind="workspace" />

        <div class="flex flex-col justify-center gap-2">
          <span class="text-sm text-vlt">Name</span>
          <EditText
            :value="tenantStore.name"
            label="Name"
            :validate="validateTenantName"
            @save="(e) => updateWorkspaceSetting('name', e)">
            <div
              :title="tenantStore.name"
              class="flex w-60 select-none items-center truncate rounded-md border px-3 py-2 text-left text-sm shadow-sm text-md border-md hover:bg-lt">
              <span class="truncate">{{ tenantStore.name }}</span>
            </div>
          </EditText>
        </div>
      </div>
    </SettingsSection>

    <SettingsSection title="Preferences" no-divider>
      <SettingsRow
        v-if="pageStore.showAlpha"
        title="Disable backlogs"
        subtitle="This will turn all backlogs off—they can always be reenabled">
        <Toggle :value="!tenantStore.backlogEnabled" @update="(e) => updateWorkspaceSetting('backlogEnabled', !e)" />
      </SettingsRow>
      <SettingsRow title="Workspace ID">
        <SettingsCopyText :text="tenantStore.duid" label="Workspace ID" class="w-48" />
      </SettingsRow>
    </SettingsSection>
  </div>
</template>
